export const FAMILYCONTACT_LOADING = "FAMILYCONTACT_LOADING";
export const FAMILYCONTACT_RESET = "FAMILYCONTACT_RESET";
export const GET_FAMILYCONTACT = "GET_FAMILYCONTACT";
export const GET_FAMILYCONTACT_SUCCESS = "GET_FAMILYCONTACT_SUCCESS";
export const GET_FAMILYCONTACT_FAIL = "GET_FAMILYCONTACT_FAIL";
export const DELETE_FAMILYCONTACT = "DELETE_FAMILYCONTACT"
export const DELETE_FAMILYCONTACT_SUCCESS = "DELETE_FAMILYCONTACT_SUCCESS"
export const DELETE_FAMILYCONTACT_FAIL = "DELETE_FAMILYCONTACT_FAIL"
export const UPDATE_FAMILYCONTACT = "UPDATE_FAMILYCONTACT"
export const UPDATE_FAMILYCONTACT_SUCCESS = "UPDATE_FAMILYCONTACT_SUCCESS"
export const UPDATE_FAMILYCONTACT_FAIL = "UPDATE_FAMILYCONTACT_FAIL"
export const ADD_NEW_FAMILYCONTACT = "ADD_NEW_FAMILYCONTACT"
export const ADD_FAMILYCONTACT_SUCCESS = "ADD_FAMILYCONTACT_SUCCESS"
export const ADD_FAMILYCONTACT_FAIL = "ADD_FAMILYCONTACT_FAIL"